<div class="d-flex">
  <div class="col-8">
    <h1 class="page-title me-auto">My time</h1>
  </div>
  <div class="col-4">
    <lib-ee-client-switcher></lib-ee-client-switcher>
  </div>
</div>
<ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="active">
  <li *ngIf="hasClockAccess" [ngbNavItem]="1">
    <a ngbNavLink class="tab-title">Timesheet</a>
    <ng-template ngbNavContent>
      <lib-timesheet></lib-timesheet>
    </ng-template>
  </li>
  <li *ngIf="hasScheduleAccess" [ngbNavItem]="2">
    <a ngbNavLink class="tab-title">Calendar</a>
    <ng-template ngbNavContent>
      <lib-calendar></lib-calendar>
    </ng-template>
  </li>
  <li *ngIf="hasPTOAccess" [ngbNavItem]="3">
    <a ngbNavLink class="tab-title">Time Off</a>
    <ng-template ngbNavContent>
      <lib-time-off></lib-time-off>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav"></div>
